<p>
  change-log-template works!
</p>
